module.exports = __webpack_public_path__ + "static/media/J-Clubs.2bbbbd0d.svg";